import script from "./AIHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIHeader.vue?vue&type=script&lang=ts&setup=true"

import "./AIHeader.vue?vue&type=style&index=0&id=49da2cfd&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49da2cfd"]])

export default __exports__